import React, { useEffect, useState } from "react";
import Button from "../button/ButtonController.jsx";
import { useIntl, FormattedMessage } from "react-intl";
import Field from "../../atoms/field/Field.jsx";
import { isValid as isValidIBAN } from "iban";

export default function PaymentInHouse({
  onSave,
  hasBeenClicked,
  setHasBeenClicked,
  customer,
  addInvoicePaymentMethod,
  addSepaPaymentMethod,
  sepaCsvEmail,
  companyAddress,
  gmbhName,
  creditorIdentifier,
  clearErrors,
  isFromRegistrationForm = false,
}) {
  const intl = useIntl();
  const [message, setMessage] = useState(null);
  const [paymentType, setPaymentType] = useState("");
  const [isFormValid, setIsFormValid] = useState(false);
  const [selectedPaymentMethod, setSelectedPaymentMethod] = useState("");
  const [accountHolderName, setAccountHolderName] = useState("");
  const [iban, setIban] = useState("");
  const [sepaMandateAccepted, setSepaMandateAccepted] = useState(false);
  const formattedCompanyAddress = companyAddress
    .split("\n")
    .map((part) => part.trim())
    .join(", ");

  useEffect(() => {
    if (addInvoicePaymentMethod && !addSepaPaymentMethod) {
      setSelectedPaymentMethod("invoice");
      setPaymentType("invoice");
      setIsFormValid(true);
    } else if (!addInvoicePaymentMethod && addSepaPaymentMethod) {
      setSelectedPaymentMethod("sepa");
      setPaymentType("sepa");
      validateForm();
    } else if (addInvoicePaymentMethod && addSepaPaymentMethod) {
      setSelectedPaymentMethod("invoice");
      setPaymentType("invoice");
      setIsFormValid(true);
    }
  }, [addInvoicePaymentMethod, addSepaPaymentMethod]);

  const togglePaymentMethod = (method) => {
    if (clearErrors) clearErrors();

    setSelectedPaymentMethod(method);
    setIsFormValid(false);
    if (method === "invoice") {
      setPaymentType("invoice");
      setIsFormValid(true);
    } else if (method === "sepa") {
      setPaymentType("sepa");
      validateForm();
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setHasBeenClicked(true);
    onSave(paymentType, { accountHolderName, iban });
  };

  const validateForm = () => {
    if (paymentType === "sepa") {
      const isIbanValid = isValidIBAN(iban);

      setIsFormValid(accountHolderName && isIbanValid && sepaMandateAccepted);
    }
  };

  useEffect(() => {
    validateForm();
  }, [accountHolderName, iban, sepaMandateAccepted]);

  return (
    <form id="payment-form">
      <div className="toggle-buttons-container">
        {addInvoicePaymentMethod && (
          <div
            className={`toggle-button ${
              selectedPaymentMethod === "invoice" ? "active" : ""
            }`}
            onClick={() => togglePaymentMethod("invoice")}
          >
            <FormattedMessage id="invoice" defaultMessage="Auf Rechnung" />
          </div>
        )}
        {addSepaPaymentMethod && (
          <div
            className={`toggle-button ${
              selectedPaymentMethod === "sepa" ? "active" : ""
            }`}
            onClick={() => togglePaymentMethod("sepa")}
            style={{ marginLeft: "20px" }}
          >
            SEPA
          </div>
        )}
      </div>

      {selectedPaymentMethod === "sepa" && (
        <div style={{ marginTop: "30px" }}>
          <Field
            label={intl.formatMessage({ id: "accountHolder" }) + " *"}
            name="account_holder"
            value={accountHolderName}
            onChange={(e) => setAccountHolderName(e.target.value)}
            required
          />
          <Field
            label="IBAN *"
            name="iban"
            value={iban}
            onChange={(e) => setIban(e.target.value)}
            required
          />
          <div
            style={{
              marginTop: "20px",
              padding: "10px",
              border: "1px solid #ccc",
              borderRadius: "5px",
              backgroundColor: "#f1f7fd",
              color: "#003366",
            }}
          >
            <p style={{ fontWeight: "bold", fontSize: "1.2em" }}>
              <FormattedMessage id="sepaMandate" />
            </p>
            <p>
              <strong>
                <FormattedMessage id="dealer" />:
              </strong>{" "}
              {formattedCompanyAddress}
            </p>
            <p>
              <strong>
                <FormattedMessage id="creditorIdentifier" />
              </strong>
              {creditorIdentifier}
            </p>
            <p>
              <strong>
                <FormattedMessage id="mandateReferenceNumber" />{" "}
              </strong>
              {customer.id}
            </p>
            <p>
              <FormattedMessage
                id="mandateAuthorisationStatement"
                values={{
                  strong: (chunks) => <strong>{chunks}</strong>,
                  gmbhName: gmbhName,
                }}
              />
            </p>
            <p>
              <FormattedMessage
                id="refundStatement"
                values={{
                  strong: (chunks) => <strong>{chunks}</strong>,
                }}
              />
            </p>
          </div>
          <div
            style={{ marginTop: "20px", display: "flex", alignItems: "center" }}
          >
            <input
              type="checkbox"
              id="sepaMandateCheckbox"
              checked={sepaMandateAccepted}
              onChange={(e) => setSepaMandateAccepted(e.target.checked)}
              style={{ marginRight: "10px" }}
            />
            <label htmlFor="sepaMandateCheckbox" style={{ fontSize: "1em" }}>
              <FormattedMessage id="confirmSepa" />
            </label>
          </div>
        </div>
      )}

      <div style={{ marginTop: "30px" }}>
        <Button
          style={{ backgroundColor: "var(--colorSecondary)" }}
          onClick={handleSubmit}
          disabled={!isFormValid || hasBeenClicked}
          className="button-confirm-payment"
        >
          {hasBeenClicked ? (
            <span style={{ color: "black" }}>
              <FormattedMessage id="processing" />
            </span>
          ) : (
            <FormattedMessage id="confirm" />
          )}
        </Button>
      </div>
      {message && <div id="payment-message">{message}</div>}
    </form>
  );
}
